/**
 * Shared helper: resolve a document reference to a frontend route.
 *
 * Used by VatReturnCase (ticket.document), ContactEntry (entry reference),
 * and JournalView (entryDocument).
 *
 * Returns { to, label } where `to` is null when no valid route exists
 * (caller should render plain text, never a dead link).
 */

const DOCUMENT_ROUTES: Record<string, string> = {
  invoice:            '/main/sale/invoice/view/',
  provider_invoice:   '/main/purchase/invoice/view/',
  'provider-invoice': '/main/purchase/invoice/view/',
  expense:            '/main/purchase/expense/view/',
  entry:              '/main/accounting/entry/view/',
  quote:              '/main/sale/quote/view/',
  order:              '/main/sale/order/view/',
  sale:               '/main/pos/view/',
}

export function resolveDocumentRoute(type: string | undefined | null, id: string | undefined | null): string | null {
  if (!type || !id) return null
  const base = DOCUMENT_ROUTES[type]
  if (!base) return null
  return base + id
}
